// import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import locale from 'element-plus/dist/locale/zh-cn.mjs'
import './styles/index.scss'
// import 'virtual:svg-icons-register'
import install from './install'
import { createPersistedState } from 'pinia-persistedstate-plugin'
import { umengInit } from '@/utils/common/umeng'
// import { TUIComponents, TUIChatKit } from "./TUIKit";
// import { TUILogin } from "@tencentcloud/tui-core";
// import { TUICallKitServer } from '@tencentcloud/call-uikit-vue'

const app = createApp(App)
const pinia = createPinia()
pinia.use(createPersistedState())
app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale })
app.use(install)
umengInit(app)

// const userSig = localStorage.getItem("sig");
// const SDKAppID = parseInt(localStorage.getItem("imSdkAppid") || "1400128918");
// const userID = localStorage.getItem("ide"); // User ID
//
// // TUIChatKit add TUIComponents
// TUIChatKit.components(TUIComponents, app);
// // TUIChatKit init
// TUIChatKit.init();
// // TUICore login
// TUILogin.login({
//   SDKAppID,
//   userID,
//   // UserSig 是用户登录即时通信 IM 的密码，其本质是对 UserID 等信息加密后得到的密文。
//   // 该方法仅适合本地跑通 Demo 和功能调试，详情请参见 https://cloud.tencent.com/document/product/269/32688
//   userSig,
//   // 如果您需要发送图片、语音、视频、文件等富媒体消息，请设置为 true
//   useUploadPlugin: true,
//   // 本地审核可识别、处理不安全、不适宜的内容，为您的产品体验和业务安全保驾护航
//   // 此功能为增值服务，请参考：https://cloud.tencent.com/document/product/269/79139
//   // 如果您已购买内容审核服务，开启此功能请设置为 true
//   useProfanityFilterPlugin: false,
//   framework: "vue3",
// });
// TUICallKitServer.init({ SDKAppID, userID, userSig })

app.mount('#app')
